import { render, staticRenderFns } from "./c4CustomerHistory.vue?vue&type=template&id=33526b02"
import script from "./c4CustomerHistory.vue?vue&type=script&lang=js"
export * from "./c4CustomerHistory.vue?vue&type=script&lang=js"
import style0 from "./c4CustomerHistory.vue?vue&type=style&index=0&id=33526b02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports